import {LegacyMeasurement} from 'constants/MeasurementConstants';
import {getMaxSignificantFigures} from 'constants/SampleConstants';
import {
  MaybeMixedMeasurement,
  MaybeMixedPlateMaterialInputId,
} from 'samples/plate-maps/transfer-table/FillPlateTransferTableConstants';
import {PlateMapErrorLevel} from 'samples/plate-maps/validation/ValidationTypes';

// Error messages
export const INVALID_MATERIAL_INPUT_ERROR_MESSAGE = 'Invalid material input association';
export const BASE_WRONG_SCHEMA_MATERIAL_INPUT_ERROR_MESSAGE = 'Content must be of schema';
export const FINAL_CONCENTRATION_MUST_MATCH_ERROR_MESSAGE =
  'Final concentration values must be the same for duplicate contents in a well';
export const TRANSFER_QUANTITIES_EXCEED_AVAILABLE_SOURCE_QUANTITY_ERROR_MESSAGE =
  'Transfer quantities exceed available quantity in source';
export const SUM_OF_TRANSFER_QUANTITIES_EXCEEDS_TOTAL_QUANTITY_ERROR_MESSAGE =
  'Transfer quantities exceed total well volume';
export const WELL_QUANTITY_EXCEEDS_FINAL_QUANTITY_ERROR_MESSAGE =
  'Quantity of existing contents exceeds total well volume';
export const MEASUREMENT_HAS_TOO_MANY_SIGFIGS_MESSAGE = `Value exceeds the maximum allowed precision of ${getMaxSignificantFigures()} significant figures and will be truncated`;

export const VALIDATION_FAILED_MESSAGE = 'Plate map validation failed';

export const MULTIPLE_SUMMARY_ERRORS = 'Multiple errors - resolve in well view';

export interface ReagentValueValidationError {
  level: PlateMapErrorLevel;
  message: string;
}

export interface MaterialInputWithError {
  materialInputId: string;
  error: ReagentValueValidationError | null;
}

export interface MaybeMixedMaterialInputWithError {
  materialInputId: MaybeMixedPlateMaterialInputId;
  error: ReagentValueValidationError | null;
}

export interface MeasurementValidationErrors {
  valueError: ReagentValueValidationError | null;
  unitsError: ReagentValueValidationError | null;
}

export interface MeasurementWithErrors<T = LegacyMeasurement> {
  measurement: T;
  errors: MeasurementValidationErrors;
}

export interface MaybeMixedMeasurementWithErrors {
  measurement: MaybeMixedMeasurement;
  errors: MeasurementValidationErrors;
}

export const DEFAULT_MEASUREMENT_VALIDATION_ERRORS: MeasurementValidationErrors = {
  valueError: null,
  unitsError: null,
};
